export const availableRegions = [
	{ name: 'Virginia', code: 'us-east-1' },
	{ name: 'Ohio', code: 'us-east-2' },
	{ name: 'California', code: 'us-west-1' },
	{ name: 'Oregon', code: 'us-west-2' },
	{ name: 'Cape Town', code: 'af-south-1' },
	{ name: 'Hong Kong', code: 'ap-east-1' },
	{ name: 'Osaka', code: 'ap-northeast-3' },
	{ name: 'Seoul', code: 'ap-northeast-2' },
	{ name: 'Mumbai', code: 'ap-south-1' },
	{ name: 'Singapore', code: 'ap-southeast-1' },
	{ name: 'Sydney', code: 'ap-southeast-2' },
	{ name: 'Tokyo', code: 'ap-northeast-1' },
	{ name: 'Central', code: 'ca-central-1' },
	{ name: 'Beijing', code: 'cn-north-1' },
	{ name: 'Ningxia', code: 'cn-northwest-1' },
	{ name: 'Frankfurt', code: 'eu-central-1' },
	{ name: 'Ireland', code: 'eu-west-1' },
	{ name: 'London', code: 'eu-west-2' },
	{ name: 'Milan', code: 'eu-south-1' },
	{ name: 'Paris', code: 'eu-west-3' },
	{ name: 'Stockholm', code: 'eu-north-1' },
	{ name: 'Bahrain', code: 'me-south-1' },
	{ name: 'São Paulo', code: 'sa-east-1' },
	{ name: 'US-East', code: 'us-gov-east-1' },
	{ name: 'US-East', code: 'us-gov-west-1' },
];
